import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Post, PostReaction } from "../../../app/app.interfaces";
import { LoginRequired } from "../../../decorators/login.required";
import { AuthService } from "../../../services/auth.service";
import { FormHelper } from "../../../helpers/form.helper";
import { UserGroupService } from "../../../services/user-group.service";
import { ApiService } from "../../../services/api.service";
import { IonicHelper } from "../../../helpers/ionic.helper";
import { EventService } from "../../../services/event.service";
import { UserService } from "../../../services/user.service";
import { ButtonStyle } from '../../upload/file-upload';

@Component({
  selector: 'reaction-create',
  templateUrl: 'reaction-create.html'
})

export class ReactionCreate implements OnInit{

	form: FormGroup;
  buttonStyleButton = ButtonStyle.Button;
	@Input() post: Post;
	@Input() parentReaction: PostReaction;
	@Output() reacted: EventEmitter<PostReaction|void> = new EventEmitter<PostReaction|void>();

	@ViewChild('inputCard') inputCard: ElementRef;

	constructor (private formHelper: FormHelper,
							 private formBuilder: FormBuilder,
							 public authService: AuthService,
							 public userGroupService: UserGroupService,
							 private apiService: ApiService,
							 private ionic: IonicHelper,
							 private eventService: EventService,
							 private userService: UserService){


	  
  	this.formHelper.buildPostReactionForm().then((form) => {
  		this.form = form;
		});
  	
	}

	cancel(): void{
		this.reacted.emit();
	}

	ngOnInit(): void {
	}

	submitForm(): void {

		this.ionic.toggleLoader(true);

		if(this.form.valid){
      //
			// let reactionObject: any = {
			// 	content: this.form.get('content').value,
			// 	post: this.post
			// };
			
			let newReaction: any = FormHelper.createObjectFromFormValues(this.form);
			newReaction.post = this.post;

			if(!!this.parentReaction) {
				newReaction.parentReaction = this.parentReaction;
			}

			console.log(newReaction);

			this.apiService.createResource('post_reactions', newReaction).then((reaction: PostReaction)  =>{
				
				this.ionic.toggleLoader(false);
				let toastMsg = (this.parentReaction) ? 'REACTION.CHILD_PLACED':'REACTION.PLACED';
	      this.ionic.toast(toastMsg);
	      
				this.reacted.emit(reaction);
				
				
				//Reload user stats
				this.userService.reloadAuthenticatedUser();

				//Reload usergroups to update usergroup stats..bit overkill but okay for now
				this.userGroupService.loadUserGroups();

				//Reload posts to propagate num answers				
        this.eventService.reloadPosts.emit();
        
        this.eventService.toggleKeyboard.emit(false);
				
				this.clearForm();
				

			}).catch((err) => {
				console.error(err);
				this.ionic.toggleLoader(false);
        this.ionic.alert('GLOBAL.GENERAL_ERROR');
			});
		}
		else {
			this.ionic.toggleLoader(false);
			this.ionic.invalidFieldsAlert(
				'REACTION.ERROR',
				null,
				'REACTION.ERRORS',
				FormHelper.getInvalidFormControls(this.form.controls)
			);
		}

	}
	
	
  
  clearForm(): void {
    this.form.setControl('attachments', new FormArray([]));
    let attachmentControls = this.form.get('attachments') as FormArray;   
    let newFormControl = new FormControl();
    attachmentControls.push(newFormControl);  
    
    this.form.reset();
  }
	
	
	addAttachmentField(): void {    
    let newFormControl = new FormControl(null);
    let attachmentControls = this.form.get('attachments') as FormArray;
    attachmentControls.push(newFormControl);
  }
	
  attachmentUploadError(ev){
    this.ionic.alert('POST_CREATE.ADD_ATTACHMENT_ERROR');
  }
  
	removeAttachmentField(i): void {
    (this.form.get('attachments') as any).removeAt(i);
  }

}




// WEBPACK FOOTER //
// ./src/partials/reaction/reaction-create/reaction-create.ts